import { useCallback } from 'react';

import { useClearRefinements, useInstantSearch } from 'react-instantsearch';

import { useTracking } from '@change-corgi/core/react/tracking';

type Result = ModelHookResult<
	{
		hideButton: boolean;
	},
	{
		clearRefine: () => void;
	}
>;

export function useClearAllFilters(): Result {
	const { canRefine, refine: clearRefine } = useClearRefinements();
	const { results } = useInstantSearch();

	const track = useTracking();
	return {
		data: {
			hideButton: !canRefine,
		},
		actions: {
			clearRefine: useCallback(() => {
				clearRefine();
				void track('search', { q: results.query || '', context: 'clear_filters_modal_button' });
			}, [clearRefine, results.query, track]),
		},
	};
}
